export class SelectedVersion {

  constructor() { }

  public version: string;
  public author: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/user/model/SelectedVersionList.ts